export default __webpack_public_path__ + "static/media/ITR-44.ea127888.png";